import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";

import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";
import {
	Button,
	Alert,
	Card,
	CardImg,
	CardBody,
	CardTitle,
	CardSubtitle,
	CardText,
} from "react-bootstrap";

import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { ThemeProvider } from '@mui/material'

const UseCases = () => (
	<ThemeProvider theme={theme}>
      <GlobalStyles/>
      <div className='fillOutPage property'>
		<Header />
        
		<main className="my-5 py-5 background-color: #f0f0f0; ">
			<Container className="px-0">
            
				<Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
                    <Card>
        {/* <div className="video-responsive position-relative"> */}
      <iframe
        width="auto"
        height="335"
        src={`https://www.youtube.com/embed/DUgIlghrR64?controls=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded YouTube"
      ></iframe>
			{/* </div> */}
        </Card>
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							className="pt-5 text-secondary text-justify"
							style={{
								fontSize: "0.9rem",
								whiteSpace: "pre-line",
							}}
						>
							<p style={{ textAlign: 'justify' }}>A large language model(GPT2) tailored for a custom Human Resource dataset in a local GPU environment enhances HR operations by leveraging advanced NLP capabilities. Fine-tuned on HR-specific data such as employee communications, this model ensures secure, private processing of sensitive information within the organization's infrastructure. The local GPU accelerates training and real-time application, enabling efficient tasks like candidate screening, employee sentiment analysis, and automated report generation. This bespoke solution provides accurate, context-aware insights, empowering HR professionals to make data-driven decisions, improve operational efficiency, and enhance the overall employee experience.</p>
						</article>
                        </div>

						</Card>
        </Fragment>
					</Col>
				</Row>


                <Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
		<Card>
        {/* <div className="video-responsive position-relative"> */}
      <iframe
       width="auto"
       height="335"
        src={`https://www.youtube.com/embed/oanJAAqVSEA?controls=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded YouTube"
      ></iframe>
			{/* </div> */}
        </Card>
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							className="pt-5 text-secondary text-justify"
							style={{
								fontSize: "0.9rem",
								whiteSpace: "pre-line",
							}}
						>
							<p style={{ textAlign: 'justify' }}>A large language model(Tiny-Llama) for a custom Human Resource dataset in a local GPU environment leverages advanced NLP to enhance HR tasks like employee communication. Fine-tuned on HR-specific data, it ensures secure, private processing within the organization's infrastructure. The local GPU accelerates training and real-time applications, providing accurate, context-aware insights. This solution empowers HR professionals to make data-driven decisions, improve efficiency, and enhance the employee experience.</p>
						</article>
                        </div>

						</Card>
        </Fragment>
					</Col>
				</Row>


                <Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
		<Card>
        {/* <div className="video-responsive position-relative"> */}
      <iframe
        width="auto"
        height="335"
        src={`https://www.youtube.com/embed/oW2zgWUEi6w?controls=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded YouTube"
      ></iframe>
			{/* </div> */}
        </Card>
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							className="pt-5 text-secondary text-justify"
							style={{
								fontSize: "0.9rem",
								whiteSpace: "pre-line",
							}}
						>
							<p style={{ textAlign: 'justify' }}>A large language model(Microsoft/Phi1.5) for a custom Human Resource dataset in a local GPU environment with real-time data using Retrieval-Augmented Generation (RAG) enhances HR tasks like employee commincation. Fine-tuned on HR-specific data, it ensures secure, private processing. The local GPU accelerates training and applications, while RAG integrates real-time data for accurate, context-aware insights. This solution empowers HR professionals to make data-driven decisions, improve efficiency, and enhance the employee experience.</p></article>
                        </div>

		</Card>
        </Fragment>
					</Col>
				</Row>

                <Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
		<Card>
        {/* <div className="video-responsive position-relative"> */}
      <iframe
        width="auto"
        height="335"
        src={`https://www.youtube.com/embed/fo7wtH72GSY?controls=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded YouTube"
      ></iframe>
			{/* </div> */}
        </Card>
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							className="pt-5 text-secondary text-justify"
							style={{
								fontSize: "0.9rem",
								whiteSpace: "pre-line",
							}}
						>
							<p style={{ textAlign: 'justify' }}>A large language model tailored for a custom Human Resource dataset in a local GPU environment enhances HR operations through advanced NLP. Fine-tuned on HR-specific data, it ensures secure, private processing of sensitive information. The local GPU accelerates training and real-time applications, enabling efficient tasks like employee communication. This solution empowers HR professionals to make data-driven decisions, improve efficiency, and enhance the employee experience.</p></article>
                        </div>

		</Card>
        </Fragment>
					</Col>
				</Row>


                <Row
					noGutters
					className="pt-2 pt-md-5 w-100 
						px-4 px-xl-0 position-relative"
				>
					<Col
						xs={{ order: 2 }}
						md={{ size: 4, order: 1 }}
						tag="aside"
						className="pb-5 mb-5 pb-md-0 
							mb-md-0 mx-auto mx-md-0"
					>
                    <Fragment>
	
		<Card>
        {/* <div className="video-responsive position-relative"> */}
      <iframe
        width="auto"
        height="335"
        src={`https://www.youtube.com/embed/T388dCJoBpk?controls=0`}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded YouTube"
      ></iframe>
			{/* </div> */}
        </Card>
        </Fragment>
					</Col>

					<Col
						xs={{ order: 1 }}
						md={{ size: 7, offset: 1 }}
						tag="section"
						className="py-5 mb-5 py-md-0 mb-md-0"
					>
					 <Fragment><Card>
                     <div className="position-relative">
                     <article
							className="pt-5 text-secondary text-justify"
							style={{
								fontSize: "0.9rem",
								whiteSpace: "pre-line",
							}}
						>
							<p style={{ textAlign: 'justify' }}>Analyzing Amazon product reviews using Natural Language Processing (NLP) in a Spark Machine Learning (ML) environment involves leveraging Spark's distributed computing capabilities for large-scale data processing. The Amazon product reviews dataset typically consists of text reviews, ratings, and other metadata.

In this environment, NLP techniques are applied to extract insights from the textual content. This can include sentiment analysis to understand customer opinions, topic modeling to identify common themes, or even text summarization for a quick overview of reviews. Spark MLlib and Spark NLP libraries can be used for these tasks, allowing for scalable and efficient processing of the dataset across a cluster of machines.

By utilizing Spark's parallel processing capabilities, organizations can derive valuable insights from the Amazon product reviews dataset, enabling them to make informed decisions related to product improvements, marketing strategies, and customer satisfaction.</p></article>
                        </div>

		</Card>
        </Fragment>
					</Col>
				</Row>




			</Container>
		</main><Footer />
		</div>
  </ThemeProvider>
);

export default UseCases;


// const UseCases = () => (
// 	<Fragment>
// 		<Header />
        
// 		<main className="my-5 py-5 background-color: #f0f0f0; ">
// 			<Container className="px-0">
            
// 				<Row
// 					noGutters
// 					className="pt-2 pt-md-5 w-100 
// 						px-4 px-xl-0 position-relative"
// 				>
// 					<Col
// 						xs={{ order: 2 }}
// 						md={{ size: 4, order: 1 }}
// 						tag="aside"
// 						className="pb-5 mb-5 pb-md-0 
// 							mb-md-0 mx-auto mx-md-0"
// 					>
//                     <Fragment>
	
//                     <Card>
//         {/* <div className="video-responsive position-relative"> */}
//       <iframe
//         width="auto"
//         height="335"
//         src={`https://www.youtube.com/embed/DUgIlghrR64?controls=0`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//         allowFullScreen
//         title="Embedded YouTube"
//       ></iframe>
// 			{/* </div> */}
//         </Card>
//         </Fragment>
// 					</Col>

// 					<Col
// 						xs={{ order: 1 }}
// 						md={{ size: 7, offset: 1 }}
// 						tag="section"
// 						className="py-5 mb-5 py-md-0 mb-md-0"
// 					>
// 					 <Fragment><Card>
//                      <div className="position-relative">
//                      <article
// 							className="pt-5 text-secondary text-justify"
// 							style={{
// 								fontSize: "0.9rem",
// 								whiteSpace: "pre-line",
// 							}}
// 						>
// 							<p style={{ textAlign: 'justify' }}>A large language model(GPT2) tailored for a custom Human Resource dataset in a local GPU environment enhances HR operations by leveraging advanced NLP capabilities. Fine-tuned on HR-specific data such as employee communications, this model ensures secure, private processing of sensitive information within the organization's infrastructure. The local GPU accelerates training and real-time application, enabling efficient tasks like candidate screening, employee sentiment analysis, and automated report generation. This bespoke solution provides accurate, context-aware insights, empowering HR professionals to make data-driven decisions, improve operational efficiency, and enhance the overall employee experience.</p>
// 						</article>
//                         </div>

// 						</Card>
//         </Fragment>
// 					</Col>
// 				</Row>


//                 <Row
// 					noGutters
// 					className="pt-2 pt-md-5 w-100 
// 						px-4 px-xl-0 position-relative"
// 				>
// 					<Col
// 						xs={{ order: 2 }}
// 						md={{ size: 4, order: 1 }}
// 						tag="aside"
// 						className="pb-5 mb-5 pb-md-0 
// 							mb-md-0 mx-auto mx-md-0"
// 					>
//                     <Fragment>
	
// 		<Card>
//         {/* <div className="video-responsive position-relative"> */}
//       <iframe
//        width="auto"
//        height="335"
//         src={`https://www.youtube.com/embed/oanJAAqVSEA?controls=0`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//         allowFullScreen
//         title="Embedded YouTube"
//       ></iframe>
// 			{/* </div> */}
//         </Card>
//         </Fragment>
// 					</Col>

// 					<Col
// 						xs={{ order: 1 }}
// 						md={{ size: 7, offset: 1 }}
// 						tag="section"
// 						className="py-5 mb-5 py-md-0 mb-md-0"
// 					>
// 					 <Fragment><Card>
//                      <div className="position-relative">
//                      <article
// 							className="pt-5 text-secondary text-justify"
// 							style={{
// 								fontSize: "0.9rem",
// 								whiteSpace: "pre-line",
// 							}}
// 						>
// 							<p style={{ textAlign: 'justify' }}>A large language model(Tiny-Llama) for a custom Human Resource dataset in a local GPU environment leverages advanced NLP to enhance HR tasks like employee communication. Fine-tuned on HR-specific data, it ensures secure, private processing within the organization's infrastructure. The local GPU accelerates training and real-time applications, providing accurate, context-aware insights. This solution empowers HR professionals to make data-driven decisions, improve efficiency, and enhance the employee experience.</p>
// 						</article>
//                         </div>

// 						</Card>
//         </Fragment>
// 					</Col>
// 				</Row>


//                 <Row
// 					noGutters
// 					className="pt-2 pt-md-5 w-100 
// 						px-4 px-xl-0 position-relative"
// 				>
// 					<Col
// 						xs={{ order: 2 }}
// 						md={{ size: 4, order: 1 }}
// 						tag="aside"
// 						className="pb-5 mb-5 pb-md-0 
// 							mb-md-0 mx-auto mx-md-0"
// 					>
//                     <Fragment>
	
// 		<Card>
//         {/* <div className="video-responsive position-relative"> */}
//       <iframe
//         width="auto"
//         height="335"
//         src={`https://www.youtube.com/embed/oW2zgWUEi6w?controls=0`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//         allowFullScreen
//         title="Embedded YouTube"
//       ></iframe>
// 			{/* </div> */}
//         </Card>
//         </Fragment>
// 					</Col>

// 					<Col
// 						xs={{ order: 1 }}
// 						md={{ size: 7, offset: 1 }}
// 						tag="section"
// 						className="py-5 mb-5 py-md-0 mb-md-0"
// 					>
// 					 <Fragment><Card>
//                      <div className="position-relative">
//                      <article
// 							className="pt-5 text-secondary text-justify"
// 							style={{
// 								fontSize: "0.9rem",
// 								whiteSpace: "pre-line",
// 							}}
// 						>
// 							<p style={{ textAlign: 'justify' }}>A large language model(Microsoft/Phi1.5) for a custom Human Resource dataset in a local GPU environment with real-time data using Retrieval-Augmented Generation (RAG) enhances HR tasks like employee commincation. Fine-tuned on HR-specific data, it ensures secure, private processing. The local GPU accelerates training and applications, while RAG integrates real-time data for accurate, context-aware insights. This solution empowers HR professionals to make data-driven decisions, improve efficiency, and enhance the employee experience.</p></article>
//                         </div>

// 		</Card>
//         </Fragment>
// 					</Col>
// 				</Row>

//                 <Row
// 					noGutters
// 					className="pt-2 pt-md-5 w-100 
// 						px-4 px-xl-0 position-relative"
// 				>
// 					<Col
// 						xs={{ order: 2 }}
// 						md={{ size: 4, order: 1 }}
// 						tag="aside"
// 						className="pb-5 mb-5 pb-md-0 
// 							mb-md-0 mx-auto mx-md-0"
// 					>
//                     <Fragment>
	
// 		<Card>
//         {/* <div className="video-responsive position-relative"> */}
//       <iframe
//         width="auto"
//         height="335"
//         src={`https://www.youtube.com/embed/fo7wtH72GSY?controls=0`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//         allowFullScreen
//         title="Embedded YouTube"
//       ></iframe>
// 			{/* </div> */}
//         </Card>
//         </Fragment>
// 					</Col>

// 					<Col
// 						xs={{ order: 1 }}
// 						md={{ size: 7, offset: 1 }}
// 						tag="section"
// 						className="py-5 mb-5 py-md-0 mb-md-0"
// 					>
// 					 <Fragment><Card>
//                      <div className="position-relative">
//                      <article
// 							className="pt-5 text-secondary text-justify"
// 							style={{
// 								fontSize: "0.9rem",
// 								whiteSpace: "pre-line",
// 							}}
// 						>
// 							<p style={{ textAlign: 'justify' }}>A large language model tailored for a custom Human Resource dataset in a local GPU environment enhances HR operations through advanced NLP. Fine-tuned on HR-specific data, it ensures secure, private processing of sensitive information. The local GPU accelerates training and real-time applications, enabling efficient tasks like employee communication. This solution empowers HR professionals to make data-driven decisions, improve efficiency, and enhance the employee experience.</p></article>
//                         </div>

// 		</Card>
//         </Fragment>
// 					</Col>
// 				</Row>


//                 <Row
// 					noGutters
// 					className="pt-2 pt-md-5 w-100 
// 						px-4 px-xl-0 position-relative"
// 				>
// 					<Col
// 						xs={{ order: 2 }}
// 						md={{ size: 4, order: 1 }}
// 						tag="aside"
// 						className="pb-5 mb-5 pb-md-0 
// 							mb-md-0 mx-auto mx-md-0"
// 					>
//                     <Fragment>
	
// 		<Card>
//         {/* <div className="video-responsive position-relative"> */}
//       <iframe
//         width="auto"
//         height="335"
//         src={`https://www.youtube.com/embed/T388dCJoBpk?controls=0`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//         allowFullScreen
//         title="Embedded YouTube"
//       ></iframe>
// 			{/* </div> */}
//         </Card>
//         </Fragment>
// 					</Col>

// 					<Col
// 						xs={{ order: 1 }}
// 						md={{ size: 7, offset: 1 }}
// 						tag="section"
// 						className="py-5 mb-5 py-md-0 mb-md-0"
// 					>
// 					 <Fragment><Card>
//                      <div className="position-relative">
//                      <article
// 							className="pt-5 text-secondary text-justify"
// 							style={{
// 								fontSize: "0.9rem",
// 								whiteSpace: "pre-line",
// 							}}
// 						>
// 							<p style={{ textAlign: 'justify' }}>Analyzing Amazon product reviews using Natural Language Processing (NLP) in a Spark Machine Learning (ML) environment involves leveraging Spark's distributed computing capabilities for large-scale data processing. The Amazon product reviews dataset typically consists of text reviews, ratings, and other metadata.

// In this environment, NLP techniques are applied to extract insights from the textual content. This can include sentiment analysis to understand customer opinions, topic modeling to identify common themes, or even text summarization for a quick overview of reviews. Spark MLlib and Spark NLP libraries can be used for these tasks, allowing for scalable and efficient processing of the dataset across a cluster of machines.

// By utilizing Spark's parallel processing capabilities, organizations can derive valuable insights from the Amazon product reviews dataset, enabling them to make informed decisions related to product improvements, marketing strategies, and customer satisfaction.</p></article>
//                         </div>

// 		</Card>
//         </Fragment>
// 					</Col>
// 				</Row>




// 			</Container>
// 		</main><Footer />
// 	</Fragment>
// );

// export default UseCases;
